/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_EyebrowInputs */



/**
* | output |
* | --- |
* | "oneAI Partner Portal" |
*
* @param {Partner_Home_EyebrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_eyebrow = /** @type {((inputs?: Partner_Home_EyebrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_EyebrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI Partnerportal")
	return /** @type {LocalizedString} */ ("oneAI Partner Portal")
});